import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Events from './components/Events';
import Filter from './components/Filters';
import DateSimulation from './components/DateSimulation';
import { useParams } from 'react-router-dom';
import Map from './components/Map';
import EventSlideout from './components/EventSlideout';
import { fetchAllLocations } from './utils';
var App = function App(props) {
  var params = useParams();
  var eventType = params.type ? params.type : nycjwEventSettings.selected_event_type;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    locations = _useState2[0],
    setLocations = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    eventTypes = _useState4[0],
    setEventTypes = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFiltersShowed = _useState6[0],
    setIsFiltersShowed = _useState6[1];
  useEffect(function () {
    fetchAllLocations().then(function (obj) {
      setLocations(_.uniqBy(obj === null || obj === void 0 ? void 0 : obj.location, "label"));
      setEventTypes(_.uniqBy(obj === null || obj === void 0 ? void 0 : obj.event_types, "term_id"));
    })["catch"](function (error) {
      return console.error(error);
    });
  }, []);
  var _useState7 = useState({
      option: 'in-person',
      location: [],
      date: [],
      types: []
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedFilters = _useState8[0],
    setSelectedFilters = _useState8[1];
  var handleSelectFilter = function handleSelectFilter(type, selected) {
    setSelectedFilters(_objectSpread(_objectSpread({}, selectedFilters), {}, _defineProperty({}, type, selected)));
  };
  var handleClearFilter = function handleClearFilter(option) {
    setSelectedFilters({
      option: option,
      location: [],
      date: [],
      types: []
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "App"
  }, nycjwEventSettings.content && /*#__PURE__*/React.createElement("div", {
    className: "event-main-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-content",
    dangerouslySetInnerHTML: {
      __html: nycjwEventSettings.content
    }
  })), nycjwEventSettings.is_admin && /*#__PURE__*/React.createElement(DateSimulation, null), /*#__PURE__*/React.createElement("div", {
    className: "main-wrapper",
    style: {
      borderTop: '4px solid #333'
    }
  }, /*#__PURE__*/React.createElement(Filter, _extends({}, props, {
    onSelectFilter: handleSelectFilter,
    onClear: handleClearFilter,
    selectedFilters: selectedFilters,
    locations: locations,
    eventTypes: eventTypes,
    showed: isFiltersShowed,
    onHide: function onHide() {
      return setIsFiltersShowed(false);
    }
  })), /*#__PURE__*/React.createElement(Events, _extends({}, props, {
    selectedFilters: selectedFilters,
    locations: locations,
    eventTypes: eventTypes,
    onShowFilters: function onShowFilters() {
      return setIsFiltersShowed(true);
    },
    onSelectFilter: handleSelectFilter
  }))), (params.event || params.type === 'virtual' && params.cat && params.cat !== 'instagram' || params.type === 'virtual' && params.cat === 'instagram' && params.event) && /*#__PURE__*/React.createElement(EventSlideout, null), /*#__PURE__*/React.createElement(Map, null));
};
export default App;